import {useLang} from "../../../hooks";
import {useNotification} from "../../../hooks/useNotification";
import {useCommonSettings} from "../../../hooks/useCommonSettings";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {CommonSettingsSchema, commonSettingsSchema} from "../schema";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {InputValidationError} from "../../../libs/error";
import {Placeholder} from "rsuite";
import {Button, Form} from "react-bootstrap";

export function CommonSettings({onLanguageEdit}) {
  const {t} = useLang();
  const {notifyError, notifySuccess} = useNotification();
  const {settings, error, isLoading, save} = useCommonSettings();
  const {
    register,
    formState: {errors},
    setValue,
    handleSubmit,
    setError
  } = useForm({
    resolver: yupResolver(CommonSettingsSchema(t))
  });

  useEffect(() => {
    if (settings) {
      setValue("is_blog", settings.is_blog?.value);
      setValue("is_ecommerce", settings.is_ecommerce?.value);
    }
  }, [settings]);

  const navigate = useNavigate();
  if (error) {
    notifyError(error);
    navigate("/dashbaord");
  }

  const handleUpdate = async (data) => {
    try {
      await save({...data, site_search_type_id: 1});
      notifySuccess({
        title:"Success",
        message:"Common Settings Updated Successfully"
      })
    } catch (err) {
      if (err instanceof InputValidationError) {
        err.setRHFError(setError);
        notifyError({
          title: "Invalid input!",
          message: err.message
        });
        return;
      }
      notifyError({
        title: "Failed to update social settings!",
        message: err.message
      });
    }
  };

  return <section id="common-settings" className="my-4">
    <h2 className="mb-3">{t("common_settings_commonSettings")}</h2>
    {isLoading ? <Placeholder.Graph active /> :
      <Form className="d-flex flex-column gap-3" onSubmit={handleSubmit(handleUpdate)}>

        <Form.Group controlId="is_blog">
          <Form.Label className="mark-required">{t("common_settings_blogSite")}</Form.Label>
          <Form.Control
            {...register("is_blog")}
            as="select"
          >
            <option value="yes">{t("settings_yes")}</option>
            <option value="no">{t("settings_no")}</option>
          </Form.Control>
          {errors.is_blog?.message && (
            <Form.Text className="text-danger">
              {errors.is_blog.message}
            </Form.Text>
          )}
        </Form.Group>

        <Form.Group controlId="is_ecommerce">
          <Form.Label className="mark-required">{t("common_settings_ecommerceSite")}</Form.Label>
          <Form.Control
            {...register("is_ecommerce")}
            as="select"
          >
            <option value="yes">{t("settings_yes")}</option>
            <option value="no">{t("settings_no")}</option>
          </Form.Control>
          {errors.is_ecommerce?.message && (
            <Form.Text className="text-danger">
              {errors.is_ecommerce.message}
            </Form.Text>
          )}
        </Form.Group>
        <div className="d-flex justify-content-end gap-2">
          <Button className="px-4" variant="success" type="submit">
            {t("common_settings_save")}
          </Button>
        </div>
      </Form>
    }

  </section>;
}